import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Archive, RotateCcw, Move, X } from "lucide-react";
import { Dialog, DialogTrigger } from "@shadcn-in-nx/ui/dialog";
import Button from "../../../components/Button.jsx";
import WorkflowMoveDialog from "./WorkflowMoveDialog";

export default function WorkflowBulkActions({
    selectedCount,
    showArchive,
    showUnarchive,
    availableApps,
    onArchive,
    onUnarchive,
    onMove,
    onClear,
}) {
    const { t } = useTranslation();
    const [showMoveDialog, setShowMoveDialog] = useState(false);

    if (selectedCount === 0) return null;

    return (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
                <span className="text-sm text-blue-800">
                    {t("workflowIndex.bulkActions.workflowsSelected", {
                        count: selectedCount,
                    })}
                </span>
                <div className="flex flex-wrap sm:flex-nowrap items-center gap-2">
                    {showArchive && (
                        <Button
                            variant="outline"
                            size="sm"
                            onClick={onArchive}
                            className="flex items-center gap-1 sm:gap-2"
                        >
                            <Archive className="h-4 w-4" />
                            <span className="hidden sm:inline">
                                {t("workflowIndex.bulkActions.archiveSelected")}
                            </span>
                            <span className="sm:hidden">
                                {t("workflowIndex.bulkActions.archiveMobile")}
                            </span>
                        </Button>
                    )}
                    {showUnarchive && (
                        <Button
                            variant="outline"
                            size="sm"
                            onClick={onUnarchive}
                            className="flex items-center gap-1 sm:gap-2"
                        >
                            <RotateCcw className="h-4 w-4" />
                            <span className="hidden sm:inline">
                                {t(
                                    "workflowIndex.bulkActions.unarchiveSelected"
                                )}
                            </span>
                            <span className="sm:hidden">
                                {t("workflowIndex.bulkActions.unarchiveMobile")}
                            </span>
                        </Button>
                    )}
                    <Dialog
                        open={showMoveDialog}
                        onOpenChange={setShowMoveDialog}
                    >
                        <DialogTrigger asChild>
                            <Button
                                variant="outline"
                                size="sm"
                                className="flex items-center gap-1 sm:gap-2"
                            >
                                <Move className="h-4 w-4" />
                                <span className="hidden sm:inline">
                                    {t("workflowIndex.bulkActions.moveToGroup")}
                                </span>
                                <span className="sm:hidden">
                                    {t("workflowIndex.bulkActions.moveMobile")}
                                </span>
                            </Button>
                        </DialogTrigger>
                        <WorkflowMoveDialog
                            selectedCount={selectedCount}
                            availableApps={availableApps}
                            onMove={(targetAppId) => {
                                onMove(targetAppId);
                                setShowMoveDialog(false);
                            }}
                            onClose={() => setShowMoveDialog(false)}
                        />
                    </Dialog>
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={onClear}
                        className="flex items-center gap-1 sm:gap-2"
                    >
                        <X className="h-4 w-4" />
                        <span className="hidden sm:inline">
                            {t("workflowIndex.bulkActions.clearSelection")}
                        </span>
                        <span className="sm:hidden">
                            {t("workflowIndex.bulkActions.clearMobile")}
                        </span>
                    </Button>
                </div>
            </div>
        </div>
    );
}
